import React, { Fragment, memo } from 'react'
import injectStyles from 'react-jss'

import { GridItem } from 'Components/Page/StatsPageWrapper'
import ResultsTable, {
  copyDataToClipboard,
} from 'Components/Stats/ResultsTable'

const TagTable = memo(({ classes, data, currencySign }) => (
  <Fragment>
    <h1>
      AB Test
      <button
        className={classes.copyButton}
        onClick={() => copyDataToClipboard(data.legend, data.data, data.totals)}
      >
        Copy
      </button>
    </h1>
    <GridItem>
      <div className={classes.tableContainer}>
        <ResultsTable {...data} currencySign={currencySign} />
      </div>
    </GridItem>
  </Fragment>
))

const styles = {
  label: {
    position: 'relative',
    left: -8,
  },
}

export default injectStyles(styles)(TagTable)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/TagTable.js